<template>
  <Menu
    as="div"
    class="relative ml-3"
  >
    <MenuButton
      class="flex items-center ml-2 text-sm text-gray-400 bg-white border border-white rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500 group lg:p-2 lg:rounded-md"
      :class="hoverClass"
    >
      <div class="relative">
        <ld-icon
          class="w-6 h-6 fill-current"
          type="solid"
          icon="PhoneIcon"
        />
        <!-- <img
                    class="w-6 h-6 rounded-md"
                    src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                    alt=""
                  /> -->
        <!-- <span
          class="hidden ml-2 font-medium text-gray-500 group-hover:inline-block group-focus:inline-block"
          >{{ phone.status }}
          <span class="text-xs text-gray-300">({{ duration }})</span>
        </span> -->
        <span
          class="absolute bottom-0 right-0 block transform translate-x-1/2 translate-y-1/2 border-2 border-white rounded-full"
        >
          <span
            class="block h-1.5 w-1.5 rounded-full"
            :class="statusClass"
          />
        </span>
      </div>
      <ld-icon
        class="flex-shrink-0 w-5 h-5 ml-1 text-gray-400 lg:block"
        icon="ChevronDownIcon"
        aria-hidden="true"
      />
    </MenuButton>
    <transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-in"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0"
    >
      <MenuItems
        class="absolute right-0 w-48 py-1 mt-2 origin-top-right bg-white rounded-md shadow-lg ring-1 ring-black/5 focus:outline-none"
      >
        <MenuItem disabled>
          <div
            class="block w-full px-4 py-2 text-sm font-medium text-center text-gray-400 capitalize"
          >
            {{ phone.status }} ({{ duration }})
          </div>
        </MenuItem>
        <MenuItem
          v-if="$can('call', 'BackOffice')"
          v-slot="{ active }"
        >
          <button
            :class="[
              active ? 'bg-gray-100' : '',
              'block px-4 py-2 text-sm text-gray-700 w-full flex items-center justify-center',
            ]"
            @click="dialModalOpen = true"
          >
            <ld-icon
              icon="PhoneOutgoingIcon"
              class="w-4 h-4"
            />
            <span class="ml-2">Dial</span>
          </button>
        </MenuItem>
      </MenuItems>
    </transition>
    <manual-dial-modal
      v-if="dialModalOpen"
      :open="dialModalOpen"
      @close="dialModalOpen = false"
    />
  </Menu>
</template>

<script setup lang="ts">
import { PhoneStatusTypes } from '@letsdial/phone/src/lib/types'
import { DateTime } from 'luxon'
import { computed, defineComponent, onMounted, onUnmounted, ref } from 'vue'
import { usePhoneStore } from '../../store/phoneStore'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import ManualDialModal from '../ui/modals/ManualDialModal.vue'

const phone = usePhoneStore()
const duration = ref('')
const dialModalOpen = ref(false)
let timeInterval: any
const statusClass = computed(() => {
  switch (phone.status) {
    case PhoneStatusTypes.REGISTERED:
      return 'bg-teal-300'
    case PhoneStatusTypes.CONNECTING:
    case PhoneStatusTypes.REGISTERING:
      return 'bg-blue-300'
    case PhoneStatusTypes.TERMINATED:
    case PhoneStatusTypes.UNREGISTERED:
    case PhoneStatusTypes.DISCONNECTED:
      return 'bg-red-300'
    default:
      return 'bg-gray-300'
  }
})
const hoverClass = computed(() => {
  switch (phone.status) {
    case PhoneStatusTypes.REGISTERED:
      return 'hover:border-teal-300'
    case PhoneStatusTypes.CONNECTING:
    case PhoneStatusTypes.REGISTERING:
      return 'hover:border-blue-300'
    case PhoneStatusTypes.TERMINATED:
    case PhoneStatusTypes.UNREGISTERED:
    case PhoneStatusTypes.DISCONNECTED:
      return 'hover:border-red-300'
    default:
      return 'hover:border-gray-300'
  }
})
onMounted(() => {
  timeInterval = setInterval(() => {
    if (phone.statusChangedAt) {
      const diff = DateTime.now().diff(phone.statusChangedAt)
      if (diff.hours > 0) {
        duration.value = diff.toFormat('HH:mm:ss')
      } else {
        duration.value = diff.toFormat('mm:ss')
      }
    }
  }, 1000)
})
onUnmounted(() => {
  clearInterval(timeInterval)
})
</script>
